const PromotionTypeEnum = {
    PRICE: 1,
    PERCENT: 2
}
export default PromotionTypeEnum